<template>
  <div>
    <div class="header-big">
      <div class="header-box">
        <img class="logo-img" src="../assets/logo.png" alt="">
        <div class="search-box">
          <el-input class="custom" placeholder="请输入教程名称" v-model="keyword">
            <i slot="prefix" class="login-icon el-icon-search"></i>
            <div slot="suffix" class="search-btn hand" @click="handSearch">搜索</div>
          </el-input>
        </div>
        <div class="user-box">
          <div class="hand msg-box" @click="handMsg">
            <img src="../assets/msg.png" alt="">
            <div v-if="msgNumber > 0" class="point"></div>
          </div>
          <div class="hand hover">
            <el-avatar size="large" :src="userInfo.headimgUrl || circleUrl"></el-avatar>
            <div style="margin-left: 10px;">{{userInfo.username}}</div>
            <div class="user-menu">
              <div :class="['item-menu', {'select-menu': curUserMenu == item.pathName}]"
                v-for="(item,index) in userMenu" :key="index" @click="changeMenu(item)">
                {{ item.name }}
              </div>
            </div>
          </div>

          <div class="bar"></div>
          <div class="hand" @click="handExit">退出</div>
        </div>
      </div>
      <div class="header-nav">
        <div class="nav-box">
          <div
            :class="['nav-item hand',{'select-tab': curTab == item.pathName},item.name === '更多' || item.name === '全部课程'? 'genduo':'']"
            v-for="(item,index) in tabsList" :key="index" @click="changeTab(item)">
            {{ item.name }}
            <div style="position: relative;width: 100%;">
              <div class="genduoKuai" v-if="item.name === '更多'" style="width: 100%;">
                <div class="guanyu" @click.stop="changeTab(item,0)">关于我们</div>
                <div class="banzhu" @click.stop="changeTab(item,1)">帮助中心</div>
              </div>
              <div class="genduoKuai" v-else-if="item.name === '全部课程'">
                <div class="guanyu" v-for="(iitem,index) in kecList" :key="index" @click.stop="changeTab(iitem,2)">
                  {{iitem.name}}
                  <div class="kuai">
                    <div class="guanyus" v-for="(ite,idx) in iitem.children" :key="idx" @click.stop="changeTab(ite,3)">
                      {{ite.name}}
                    </div>
                    <div v-if="kecList.length > iitem.children.length">
                      <div class="kongbai" v-for="itex in (kecList.length-iitem.children.length)"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        keyword: '',
        circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        userMenu: [{
            name: '我的主页',
            pathName: 'My'
          },
          {
            name: '我的收藏',
            pathName: 'Collect'
          },
          {
            name: '我的消息',
            pathName: 'Message'
          },
          {
            name: '数据统计',
            pathName: 'TheChart'
          },
          {
            name: '个人信息',
            pathName: 'UserInfo'
          },
          {
            name: '账号安全',
            pathName: 'EditPass'
          }
        ],
        curUserMenu: '',
        tabsList: [{
            name: '首页',
            type: 0,
            pathName: 'Index'
          }, {
            name: '全部课程',
            type: 1,
            pathName: 'CourseList'
          },
          {
            name: '资讯频道',
            type: 2,
            pathName: 'NewsList'
          },
          {
            name: '资源下载',
            type: 3,
            pathName: 'ResourceList'
          },
          {
            name: '更多',
            type: 4
          }
        ],
        curTab: '',
        userInfo: {},
        kecList: [],
        msgNumber: 0
      }
    },
    watch: {
      '$route'(to) {
        if (to.name === 'NewsDetail') {
          this.curTab = 'NewsList';
        } else if (to.name === 'ResourceDetail') {
          this.curTab = 'ResourceList';
        } else {
          this.curTab = to.name;
        }

      }
    },
    inject: ["reload"],
    created() {
      if (sessionStorage.getItem('userInfo') && sessionStorage.getItem('userInfo') != undefined) {
        this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      }
    },
    mounted() {
      this.getUserInfoData();
      this.getList();
      this.getNotReadMsgNum();
    },
    methods: {
      changeMenu(item) {
        if (this.curTab === item.pathName && this.curUserMenu == item.pathName) return false;
        this.curUserMenu = item.pathName
        this.$router.push({
          name: item.pathName
        })
      },
      changeTab(item, type) {
        let data = {
          name: item.pathName
        };
        if (type === 0) {
          item.pathName = 'About';
        } else if (type === 1) {
          item.pathName = 'Help';
        } else if (type === 2) {
          item.pathName = 'CourseList';
          data.id = item.id;
        } else if (type === 3) {
          item.pathName = 'CourseList';
          data.id = item.pid;
          data.pid = item.id;
        } else {
          if (item.pathName == this.curTab) return false;
        }
        if (sessionStorage.getItem('routerUrl')) {
          if (sessionStorage.getItem('routerUrl') === item.pathName) {
            this.$router.replace({
              name: 'Index'
            })
          } else {
            sessionStorage.setItem('routerUrl', item.pathName);
          }
        } else {
          sessionStorage.setItem('routerUrl', item.pathName);
        }
        setTimeout(() => {
          this.$router.push({
            name: item.pathName,
            params: data
          })
        }, 100)

      },
      handMsg() {
        this.$http.oneKeyRead();
        this.getNotReadMsgNum()
        this.$router.push({
          name: 'Message'
        })
      },
      getUserInfoData() {
        this.$http.getUserInfoData().then((res) => {
          if (res.data) {
            this.userInfo = res.data;
            sessionStorage.setItem('userInfo', JSON.stringify(res.data));
          }
        })
      },
      handExit() {
        sessionStorage.removeItem('userInfo');
        sessionStorage.removeItem('token');
        this.$router.push({
          name: 'Login'
        })
      },
      getList() {
        let data = {
          type: 'course'
        }
        this.$http.categoryList(data).then(res => {
          this.kecList = res.data;
        })
      },
      handSearch() {
        console.log(this.$router);
        if (this.keyword) {
          if (sessionStorage.getItem('searchUrl')) {
            if (sessionStorage.getItem('searchUrl') === 'SearchList') {
              this.$router.replace({
                name: 'Index'
              })
            } else {
              sessionStorage.setItem('searchUrl', 'SearchList');
            }
          } else {
            sessionStorage.setItem('searchUrl', 'SearchList');
          }
        }
        setTimeout(() => {
          this.$router.push({
            name: this.keyword ? 'SearchList' : 'Index',
            params: {
              keyword: this.keyword
            }
          })
        }, 100)
      },
      getNotReadMsgNum() {
        this.$http.getNotReadMsgNum().then(res => {
          this.msgNumber = res.data;
        })
      }
    },
  }
</script>

<style scoped>
  .custom {
    width: 635px;
  }

  .custom>>>.el-input__inner {
    padding-left: 40px;
    padding-right: 0;
  }

  .custom>>>.login-icon {
    width: 35px;
    text-align: center;
    line-height: 40px;
    font-size: 22px;
  }
</style>
<style>
  .genduo:hover .genduoKuai {
    display: block;
  }

  .genduo .genduoKuai {
    display: none;
    position: absolute;
    top: 0%;
    background-color: #fff;
    width: 200px;
    z-index: 99;
    color: #000;
    text-align: left;
    font-size: 14px;
  }

  .genduoKuai .guanyu {
    border-left: 5px white solid;
    padding-left: 16px;
  }

  .genduoKuai .banzhu {
    border-left: 5px white solid;
    padding-left: 16px;
  }

  .genduoKuai .kongbai {
    height: 60px;
  }

  .genduoKuai .guanyu:hover {
    border-left: 5px #3CA1F1 solid;
    background-color: #F7F9FB;
  }

  .genduoKuai .banzhu:hover {
    border-left: 5px #3CA1F1 solid;
    background-color: #F7F9FB;
  }

  .genduoKuai .guanyu .kuai {
    display: none;
    position: absolute;
    top: 0%;
    left: 100%;
    background-color: #fff;
    width: 100%;
    z-index: 99;
    color: #000;
  }

  .genduoKuai .guanyu .kuai .guanyus {
    border-left: 5px white solid;
    padding-left: 16px;
  }

  .genduoKuai .guanyu:hover .kuai {
    display: block;
  }

  .genduoKuai .guanyu .kuai .guanyus:hover {
    color: #3590FE;
  }
</style>

<style scoped lang="scss">
  .header-big {
    width: 100%;
    background: #ffffff;

    .header-box {
      max-width: 1200px;
      margin: 10px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo-img {
        // width: 163px;
        // height: 66px;
        // width: 40px;
        // height: 50px;
        width: 45px;
        height: 55px;
      }

      .search-box {
        display: flex;
        align-items: center;

        .search-btn {
          width: 100px;
          line-height: 40px;
          background: #3CA1F1;
          color: #FFFFFF;
          font-size: 18px;
          border-radius: 0 4px 4px 0;
          margin-right: -5px;
        }
      }

      .user-box {
        display: flex;
        align-items: center;

        .msg-box {
          position: relative;
          margin-right: 34px;

          .point {
            position: absolute;
            top: 0;
            right: 0;
            width: 6px;
            height: 6px;
            background: #FF3210;
            border-radius: 50%;
          }
        }

        .hover {
          display: flex;
          align-items: center;
          position: relative;

          &:hover {
            .user-menu {
              display: block;
            }
          }
        }

        .bar {
          width: 1px;
          height: 16px;
          background: #E4E4E4;
          margin: 0 20px;
        }

        .user-menu {
          display: none;
          position: absolute;
          z-index: 100;
          top: 40px;
          left: 50%;
          transform: translate(-50%, 0%);
          width: 128px;
          background: #FFFFFF;
          box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);

          .item-menu {
            width: 128px;
            line-height: 44px;
            font-size: 14px;
            text-align: center;
            position: relative;
          }

          .select-menu {
            color: #3CA1F1;
            background: #F7F9FB;
          }
        }
      }
    }

    .header-nav {
      width: 100%;
      height: 60px;
      background: #3CA1F1;

      .nav-box {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;

        .nav-item {
          width: 106px;
          line-height: 60px;
          text-align: center;
          color: #FFFFFF;

        }

        .select-tab {
          background: #85C6FA;
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/headerNav.vue